import React, { useState } from "react";
import serviceProvider from '../../services/axios'
import { Modal } from "@material-ui/core";
import { inviteSvg, sendIcon, minusIcon, skillCloseIcon, leftFooterSvg, referSvg, tickSvg } from './svg'
import {
    MainPopupWrapper,
    MainPopupBothSectionWraper,
    MainPopupBothSectionLeft,
    MainPopupBothSectionRight,
    RightInviteContainer,
    RightInviteHead,
    RightInviteBody,
    NoInviteUserWrap,
    RightInviteUserWrap,
    RightInviteList,
    RightInviteListItem,
    LeftCount,
    RightEmailBox,
    RegisteredUserWrap,
    UnRegisteredUserWrap,
    InvitedUserWrap,
    EmailInput,
    SendInviteBtn,
    InvitationSuccessPopup, InvitationSuccessCard, CloseBtn, InvitationSuccessRightPopup,
    InvitationSuccessRightPopupCard, InvitationRemovePopup, InvitationRemoveRightPopup,
    InvitationRemoveRightPopupCard, InvitationRemoveBtnWrapper, ReferButton, ReferWalk
} from './styles'
import { useMemo } from "react";

export const ReferColleaguePopupView = (props) => {


    const [email, setEmail] = useState('');
    const [isMainPopup, setIsMainPopup] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSuccessPopup, setIsSuccessPopup] = useState(false);
    const [isRightSuccessPopup, setIsRightSuccessPopup] = useState(false);
    const [isRightRemovePopup, setIsRightRemovePopup] = useState(false);
    const [tmpRemoveId, setTmpRemoveId] = useState();
    const [invitedUser, setInvitedUser] = useState(props.invited_list);
    const [registeredUser, setRegisteredUser] = useState(props.resistered_list);
    const [unRegisteredUser, setUnRegisteredUser] = useState([]);
    const [sendReInvite, setSendReInvite] = useState([]);
    const user = JSON.parse(localStorage.getItem("userData"));
    const uid = user ? user.uid : 0;
    // Functions
    const checkMailValid = useMemo(() => {
        const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return emailPattern.test(email) && invitedUser?.findIndex(i => i.email == email) == -1 && registeredUser?.findIndex(i => i.email == email) == -1;
    }, [email]);
    const handleSuccessPopup = () => {


        serviceProvider.post("/user?type=invitereferral", { email: email, uid: uid }, true).then((response) => {
            if (response.data.error == 0) {
                let tmpArray = [...invitedUser];
                tmpArray.push({ email: email, id: new Date().getTime(), new: true });
                setInvitedUser(tmpArray);
                setIsSuccessPopup(true);
                setEmail('');
                setIsError(false);
                setTimeout(() => { setIsSuccessPopup(prv => false) }, 2000);
                console.log('if');
            } else {
                console.log('else');
                setIsError(true);
                //shubesh
            }

        });

    }
    const handleRightRemovePopup = (tmpId, tmpEmail, section) => {
        setTmpRemoveId({ id: tmpId, section });
        setIsRightRemovePopup(true);
        serviceProvider.post("/user?type=removereferral", { removeId: tmpEmail }, true).then((response) => {

        });
    }
    const handleRightSucessPopup = (inviteId, email) => {
        setSendReInvite(prv => {
            return [
                ...prv,
                inviteId
            ]
        })
        setIsRightSuccessPopup(true);
        setTimeout(() => {
            setIsRightSuccessPopup(prv => false);
        }, 2000);

        serviceProvider.post("/user?type=reinvitereferral", { email: email, uid: uid }, true).then((response) => {

        });
    }
    const removeUser = () => {
        let tmpArray = tmpRemoveId?.section == `invite` ? invitedUser : unRegisteredUser;
        let tmpFilterArray = tmpArray.filter((i) => i.id != tmpRemoveId?.id);
        setInvitedUser(tmpFilterArray);
        setSendReInvite(prv => prv?.filter((i) => i != tmpRemoveId?.id));
        setIsRightRemovePopup(prv => false);
    }
    const closePopup = () => {
        setInvitedUser(prv => prv.map(i => { return { ...i, new: false } }));
        setEmail('');
        setSendReInvite([]);
        setIsMainPopup(false);
    }

    return (
        <>
            <ReferWalk data-component="ReferWalk" className="refer-walk">
                <ReferButton data-component="ReferButton" onClick={() => setIsMainPopup(true)} >
                    <i dangerouslySetInnerHTML={{ __html: referSvg }}></i>
                    Refer a Colleague
                </ReferButton>
            </ReferWalk>

            <Modal
                open={isMainPopup}
                // onClose={HandleUpdgradePopup}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className=""
            >
                <MainPopupWrapper data-component="MainPopupWrapper">
                    <MainPopupBothSectionWraper data-component="MainPopupBothSectionWraper">
                        <div className="close-icon-div">
                            <button className="close-icon" onClick={() => closePopup()}>
                                <i dangerouslySetInnerHTML={{ __html: skillCloseIcon }}></i>
                            </button>
                        </div>
                        <MainPopupBothSectionLeft data-component="MainPopupBothSectionLeft">
                            <h2 className="popup-heading">Invite your colleagues</h2>
                            {/* header end */}
                            <div className="popup-body">
                                <p><b>Invite</b> your friends and colleagues to sign-up and benchmark your Industry 4.0 Skills. The more people, the better the more significative the benchmarking will be. You can invite as many people as you want.</p>
                                <EmailInput value={email} type="email" data-component="EmailInput" placeholder="Enter email ID here"
                                    onChange={(e) => { setEmail(e.target.value); setIsError(false); }}
                                    onBlur={(e) => { e.target.style.borderColor = !checkMailValid && email?.length > 0 ? 'red' : '' }}
                                />
                                <div className="send-invite-wrap">
                                    <SendInviteBtn data-component="SendInviteBtn" disabled={!checkMailValid} onClick={handleSuccessPopup}>
                                        Send Invite
                                    </SendInviteBtn>
                                    {isError ?
                                        <span className="error-msg">This Email ID is already invited!</span>
                                        :
                                        <span className="error-msg" style={{ visibility: ((invitedUser?.findIndex(i => i.email == email) == -1 && registeredUser?.findIndex(i => i.email == email) == -1)) ? 'hidden' : '' }}>This Email ID is already invited!</span>
                                    }
                                </div>

                            </div>
                            {/* body end */}
                            <div className="popup-footer">
                                <i dangerouslySetInnerHTML={{ __html: leftFooterSvg }} className="left-footer-svg"></i>
                                <span>Invited Users: <b>{invitedUser?.length}</b></span>
                                <span>Registered Users: <b>{registeredUser?.length}</b></span>
                            </div>
                            {/* popup-footer end */}
                        </MainPopupBothSectionLeft>
                        <MainPopupBothSectionRight data-component="MainPopupBothSectionRight">
                            <RightInviteContainer data-component="RightInviteContainer">
                                {registeredUser.length > 0 &&
                                    <RegisteredUserWrap data-component="RegisteredUserWrap">
                                        <RightInviteHead data-component="RightInviteHead">
                                            <span className="invite-text">REGISTERED USERS( {registeredUser?.length}/{invitedUser?.length + registeredUser?.length})
                                            </span>
                                        </RightInviteHead>
                                        <RightInviteBody data-component="RightInviteBody">
                                            <RightInviteUserWrap data-component="RightInviteUserWrap">
                                                {registeredUser?.map((item, index) => (
                                                    <RightInviteList data-component="RightInviteList" key={index}>
                                                        <RightInviteListItem data-component="RightInviteListItem">
                                                            <LeftCount data-component="LeftCount">{index + 1}.</LeftCount>
                                                            <RightEmailBox data-component="RightEmailBox">
                                                                <span className="email">{item.email}</span>
                                                            </RightEmailBox>
                                                        </RightInviteListItem>
                                                    </RightInviteList>
                                                ))}
                                            </RightInviteUserWrap>
                                        </RightInviteBody>
                                    </RegisteredUserWrap>
                                }
                                <InvitedUserWrap data-component="InvitedUserWrap">
                                    <RightInviteHead data-component="RightInviteHead">
                                        <span className="invite-text">{(registeredUser?.length > 0) ? `UN-REGESTERED USERS (${invitedUser?.length || 0}/${invitedUser?.length + registeredUser?.length})` : `INVITED USER: ${invitedUser?.length}`}
                                        </span>
                                    </RightInviteHead>
                                    <RightInviteBody data-component="RightInviteBody">
                                        {invitedUser?.length == 0 && registeredUser?.length == 0 && unRegisteredUser?.length == 0 ?
                                            <NoInviteUserWrap data-component="NoInviteUserWrap">
                                                <i dangerouslySetInnerHTML={{ __html: inviteSvg }}></i>
                                            </NoInviteUserWrap>
                                            :
                                            <RightInviteUserWrap data-component="RightInviteUserWrap">
                                                <RightInviteList data-component="RightInviteList">
                                                    {invitedUser?.map((item, index) => (
                                                        <RightInviteListItem data-component="RightInviteListItem" key={item.id}>
                                                            <LeftCount data-component="LeftCount">{index + 1}</LeftCount>
                                                            <RightEmailBox data-component="RightEmailBox">
                                                                <span className="email">{item.email}</span>

                                                                <button className="send-btn" style={{ visibility: item.new ? 'hidden' : '' }} onClick={() => !sendReInvite.includes(item.id) ? handleRightSucessPopup(item.id, item.email) : ''}>
                                                                    <i dangerouslySetInnerHTML={{ __html: sendReInvite.includes(item.id) ? tickSvg : sendIcon }}></i>
                                                                    {!sendReInvite.includes(item.id) &&
                                                                        <span className="email-tooltip">Re-invite</span>
                                                                    }
                                                                </button>

                                                                <button className="remove-btn" onClick={() => handleRightRemovePopup(item.id, item.email, `invite`)}>
                                                                    <i dangerouslySetInnerHTML={{ __html: minusIcon }}></i>
                                                                    <span className="email-tooltip">Remove</span>
                                                                </button>
                                                            </RightEmailBox>
                                                        </RightInviteListItem>
                                                    ))}
                                                </RightInviteList>
                                            </RightInviteUserWrap>
                                        }
                                    </RightInviteBody>
                                </InvitedUserWrap>
                            </RightInviteContainer>
                            {/* Popup */}
                            <InvitationSuccessRightPopup data-component="InvitationSuccessRightPopup" open={isRightSuccessPopup}>
                                <InvitationSuccessRightPopupCard data-component="InvitationSuccessRightPopupCard">
                                    <img src={require('../../assets/img/ReferColleaguePopup/right-success-img.gif').default} />
                                    <p>An invitation email has been sent successfully!</p>
                                </InvitationSuccessRightPopupCard>
                            </InvitationSuccessRightPopup>
                            {/* invitation success  popup end*/}
                            <InvitationRemoveRightPopup data-component="InvitationRemoveRightPopup" open={isRightRemovePopup}>
                                <InvitationRemoveRightPopupCard data-component="InvitationRemoveRightPopupCard">
                                    <p>Do you want to remove this user?</p>
                                    <p>You will be able to invite a new one instead.</p>
                                    <InvitationRemoveBtnWrapper data-component='InvitationRemoveBtnWrapper'>
                                        <button className="cancel-btn" onClick={() => setIsRightRemovePopup(false)}>
                                            Cancel
                                        </button>
                                        <button className="remove-btn" onClick={removeUser}>
                                            Remove
                                        </button>
                                    </InvitationRemoveBtnWrapper>
                                </InvitationRemoveRightPopupCard>
                            </InvitationRemoveRightPopup>
                            {/* remmove  popup end*/}
                        </MainPopupBothSectionRight>
                        <InvitationSuccessPopup data-component="InvitationSuccessPopup" open={isSuccessPopup}>
                            <InvitationSuccessCard data-component="InvitationSuccessCard">
                                <img className="success-img" src={require('../../assets/img/ReferColleaguePopup/success-img.gif').default} />
                                <p>Invitation sent successfully</p>
                            </InvitationSuccessCard>
                        </InvitationSuccessPopup>
                    </MainPopupBothSectionWraper>
                    {/* MainPopupBothSectionWraper end */}
                </MainPopupWrapper>
            </Modal>
        </>

    )
}